import React, { useEffect, useState } from 'react';
import { Flex, Spinner } from '@chakra-ui/react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../store/store';
import ReturnsContent from '../../components/returnsPage/tableList';
import ReturnForm from '../../components/returnsPage/form';
import { ReturnsMenu } from '../../components/returnsPage/menu';
import { getRefundsAction } from '../../../modules/refunds/actions';
import { RefundDTO } from '../../../modules/refunds/types';
import {
  selectFilteredRefunds,
  selectIsLoadingRefundList,
} from '../../../modules/refunds/selectors';
import { ReturnDetailPage } from '../../components/returnsPage/details';

const PAGE_SIZE = 10;

export const ReturnsPage: React.FC = () => {
  const dispatch = useDispatch();

  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [activeStatus, setActiveStatus] = useState<number>(0); // статус по умолчанию, например, `0`
  const [searchTerm, setSearchTerm] = useState('');
  const [visibleItems, setVisibleItems] = useState(PAGE_SIZE);
  const [isCreating, setIsCreating] = useState(false);
  const [selectedReturn, setSelectedReturn] = useState<RefundDTO | null>(null);

  useEffect(() => {
    dispatch(getRefundsAction.request());
  }, [dispatch]);

  // Получаем отфильтрованные данные из состояния с учетом даты, статуса и поискового запроса
  const filteredData = useSelector((state: RootState) =>
    selectFilteredRefunds(activeStatus, startDate, endDate, searchTerm)(state),
  );
  const isLoading = useSelector(selectIsLoadingRefundList);

  // Загружаем больше элементов, если доступно
  const handleLoadMore = () => {
    if (visibleItems < filteredData.length) {
      setVisibleItems(prev => prev + PAGE_SIZE);
    }
  };

  const handleSelectReturn = (returnData: RefundDTO) => {
    setSelectedReturn(returnData);
  };

  const handleStatusChange = (status: number) => {
    setActiveStatus(status);
    setIsCreating(false); // Возврат к таблице при переключении статуса
    setSelectedReturn(null); // Сброс выбранного возврата при смене статуса
    setVisibleItems(PAGE_SIZE); // Сброс видимых элементов при смене фильтра
  };

  const handleSearchChange = (term: string) => {
    setSearchTerm(term);
    setVisibleItems(PAGE_SIZE); // Сброс видимых элементов при поиске
  };

  const handleBack = () => {
    setSelectedReturn(null); // Сброс выбранного возврата при смене статуса
    setIsCreating(false);
  };

  return (
    <Flex height="100vh">
      {/* Левое меню */}
      <ReturnsMenu
        activeStatus={activeStatus}
        onStatusChange={handleStatusChange}
        onCreate={() => setIsCreating(true)}
      />

      {/* Правая часть */}
      {isCreating ? (
        // <ReturnForm onCancel={() => setIsCreating(false)} />
        <ReturnForm onBackClick={handleBack} />
      ) : selectedReturn ? (
        // <ReturnDetailPage returnData={selectedReturn} onBack={() => setSelectedReturn(null)} />
        <ReturnDetailPage returnData={selectedReturn} onBackClick={handleBack} />
      ) : (
        <Flex direction="column" flex="1">
          {isLoading ? (
            <Flex justifyContent="center" alignItems="center" height="100%">
              <Spinner size="xl" />
            </Flex>
          ) : (
            <ReturnsContent
              data={filteredData.slice(0, visibleItems)}
              startDate={startDate}
              endDate={endDate}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              searchTerm={searchTerm}
              setSearchTerm={handleSearchChange}
              handleLoadMore={handleLoadMore}
              visibleItems={visibleItems}
              onSelectReturn={handleSelectReturn}
            />
          )}
        </Flex>
      )}
    </Flex>
  );
};

export default ReturnsPage;
